import {
  Alert,
  Button,
  Dropdown,
  SplitButton,
  NavDropdown,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import "./login-indicator-styles.css";

const LoginIndicator = () => {
  const email = useSelector((state) => state.userInformation.email);

  const logOutFunction = () => {
    localStorage.clear();
    window.location.replace("/");
  };

  const goToDashBoardFunction = () => {
    window.location.assign("/dashboard");
  };

  return (
    <div className="ml-auto mt-2">
      {email.length > 0 ? (
        <div className="welcome-text-and-profile-icon-div">
          <div style={{ color: "white" }}>
            <p className="welcome-text"> {email}</p>
          </div>

          <NavDropdown
            title={
              <span>
                <i className="bi bi-person-circle profile-icon"></i>
              </span>
            }
            id="collasible-nav-dropdown"
          >
            <NavDropdown.Item onClick={goToDashBoardFunction}>
              Dashboard
            </NavDropdown.Item>
            <NavDropdown.Item style={{ color: "red" }} onClick={logOutFunction}>
              Log out
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      ) : (
        <Alert variant="success">
          <Alert.Link href="login">Login / Signup</Alert.Link>{" "}
        </Alert>
      )}
    </div>
  );
};

export default LoginIndicator;
